export default {
  "content": "<path d=\"M2.288 10.053c-.292-.292-.322-.74-.066-.995l6.496-6.496c.255-.256.703-.226.994.066.292.292.322.74.067.994L3.282 10.12c-.255.255-.702.225-.994-.066z\" fill=\"#717684\"/><path d=\"M8.718 10.119L2.22 3.622c-.255-.255-.225-.702.067-.994.291-.292.739-.322.994-.066l6.496 6.496c.256.255.226.703-.066.995-.292.291-.739.321-.994.066z\" fill=\"#717684\"/>",
  "attrs": {
    "width": "12",
    "height": "13",
    "viewBox": "0 0 12 13",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};